import { GetBrandRes } from "../../services";

export const tempBrandData: GetBrandRes[] = [
  {
    brandId: 1,
    brandName: "스타벅스",
    brandImgUrl: "/img/brand/starbucks.png",
    category: "카페",
  },
  {
    brandId: 2,
    brandName: "나이키",
    brandImgUrl: "/img/brand/nike.png",
    category: "옷",
  },
  {
    brandId: 3,
    brandName: "아디다스",
    brandImgUrl: "/img/brand/adidas.png",
    category: "옷",
  },
  {
    brandId: 1,
    brandName: "스타벅스",
    brandImgUrl: "/img/brand/starbucks.png",
    category: "카페",
  },
  {
    brandId: 2,
    brandName: "나이키",
    brandImgUrl: "/img/brand/nike.png",
    category: "옷",
  },
  {
    brandId: 3,
    brandName: "아디다스",
    brandImgUrl: "/img/brand/adidas.png",
    category: "옷",
  },
];
